import * as React from 'react';
import { Palette } from '../../lib/constants.js';
import { createIcon } from '../IconFactory/index.js';

const Close = createIcon('Close')(({ fillColor = Palette.NeutralGrey2, ...others }) => (React.createElement("svg", { xmlnsXlink: "http://www.w3.org/1999/xlink", width: 18, height: 18, viewBox: "0 0 18 18", ...others },
    React.createElement("path", { fill: fillColor, d: "M7.99 9L4.21 5.22a.714.714 0 0 1 1.01-1.01L9 7.99l3.78-3.78a.714.714 0 0 1 1.01 1.01L10.01 9l3.78 3.78a.714.714 0 0 1-1.01 1.01L9 10.01l-3.78 3.78a.714.714 0 0 1-1.01-1.01L7.99 9z" }))));

export { Close };
//# sourceMappingURL=index.js.map
